module.exports = __webpack_public_path__ + "img/date_valid.07a91571.svg";